<!--
 * @Author: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-15 17:00:01
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-08-25 16:30:10
 * @FilePath: \fe-crm\src\views\client\components\address-list\update-address\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="page-comp-clue-new-trip">
    <jw-modal :visible="visible" @ok="handleOk" @cancel="handleCancel" title-align="start" width="450px" :mask-closable="false" unmount-on-close :ok-loading="loading">
      <template #title> {{ title }}</template>
      <jw-form :model="form" label-align="right" auto-label-width ref="addressForm" @submit="handleSubmit" class="select-item">
        <jw-form-item field="custom" :label="$t('客户')" show-colon :rules="{ required: true, message: $t('请输入客户名称') }" :validate-trigger="['blur', 'input']">
          <jw-input :style="{ width: '320px' }" v-model="form.custom" :placeholder="$t('请输入客户名称')" disabled> </jw-input>
        </jw-form-item>
        <jw-form-item field="addressType" :label="$t('地址类型')" show-colon :rules="{ required: true, message: $t('请选择地址类型') }" :validate-trigger="['blur', 'input']">
          <jw-select v-model="form.addressType" :placeholder="$t('请选择地址类型')" :style="{ width: '320px' }" allow-clear allow-search :options="addressType"> </jw-select>
        </jw-form-item>
        <jw-form-item field="provinceCity" :label="$t('省份/城市')" show-colon :rules="{ required: true, message: $t('请选择省份/城市') }" :validate-trigger="['blur', 'input']">
          <jw-cascader :trigger-props="{ updateAtScroll: true }" :options="cityList" :placeholder="$t('请选择省份/城市')" :style="{ width: '320px' }" v-model="form.provinceCity" path-mode allow-clear allow-search />
        </jw-form-item>
        <jw-form-item field="addressDetail" :label="$t('详细地址')" show-colon :rules="{ required: true, message: $t('请输入详细地址') }" :validate-trigger="['blur', 'input']">
          <jw-input :style="{ width: '320px' }" v-model="form.addressDetail" :placeholder="$t('请输入详细地址')"> </jw-input>
        </jw-form-item>
        <jw-form-item field="postCode" :label="$t('邮政编码')" show-colon>
          <jw-input :style="{ width: '320px' }" v-model="form.postCode" :placeholder="$t('请输入邮政编码')"> </jw-input>
        </jw-form-item>
        <jw-form-item field="comment" :label="$t('备注')" show-colon>
          <jw-input :style="{ width: '320px' }" v-model="form.comment" :placeholder="$t('请输入备注')"> </jw-input>
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script>
import { reactive, toRefs, inject, ref } from 'vue';
import { Message } from '@arco-design/web-vue';
import useLoading from '@/hooks/loading';
import { clientService, publicService } from '@/api/';
import { useI18n } from 'vue-i18n';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'updateAddress',
  setup(props, ctx) {
    const { t } = useI18n();
    console.log(props, ctx);
    const data = reactive({
      visible: false,
      title: '',
      id: inject('detailParams')?.id, //客户id
      type: inject('detailParams')?.type, //客户id
      record: {},
      from: '', //编辑新增
      form: {
        customId: '',
        custom: '',
        addressType: '',
        provinceCity: '',
        addressDetail: '',
        postCode: '',
        comment: ''
      },
      addressType: [],
      cityList: []
    });
    const addressForm = ref();
    const { loading, setLoading } = useLoading(false);
    const updateAddressOpen = (record) => {
      getAddressType();
      getCityList();
      data.from = record.from;
      data.title = record.title;
      data.visible = true;
      data.form = record.list;
      if (data.from == 0) {
        data.form.provinceCity = data.form?.provinceCity?.split('/');
      }
    };
    // 获取地址类型
    const getAddressType = async () => {
      try {
        const res = await clientService.getAddressInfoType({});
        data.addressType = res?.result;
      } catch (e) {
        console.log(e);
      }
    };
    //获取省份城市
    const getCityList = async () => {
      try {
        const res = await publicService.getSelections({ fieldKey: 'city' });
        data.cityList = res?.result;
      } catch (e) {
        console.log(e);
      }
    };
    // 新建/编辑
    const updateAddress = async () => {
      data.form.provinceCity = data.form?.provinceCity?.join('/');
      setLoading(true);
      try {
        const res = await clientService.saveAddress(data.form);
        setLoading(false);
        if (res.error) {
          Message.error(res.error?.msg || t('获取数据失败'));
          return;
        } else {
          data.visible = false;
          Message.success(t('操作成功'));
          ctx.emit('cb');
        }
      } catch (e) {
        setLoading(false);
      }
    };

    // 确定按钮
    const handleOk = () => {
      addressForm.value.handleSubmit();
    };
    // 表单提交
    const handleSubmit = ({ values, errors }) => {
      console.log('values', values);
      console.log('errors', errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        addressForm.value.setFields(errorArray);
        return;
      }
      updateAddress();
    };
    //  取消按钮
    const handleCancel = () => {
      data.visible = false;
      addressForm.value.resetFields(true); //清空表单
    };
    return {
      updateAddressOpen,
      handleCancel,
      handleOk,
      handleSubmit,
      addressForm,
      loading,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
